import { render, staticRenderFns } from "./ImportArtistDivideLock.vue?vue&type=template&id=350b8637"
import script from "./ImportArtistDivideLock.vue?vue&type=script&lang=js"
export * from "./ImportArtistDivideLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports